<template>
  <div class="pa-2">
    <h4 class="settings-h4" :class="[actionType === 'add' && 'required-field']">
      Licenses
    </h4>

    <div class="wrapper-2 pa-3 mb-4 pos-relative">
      <div class="licenses-grid">
        <!-- first row -->
        <div
          class="cell header left bold main top-left-corner"
          style="grid-row: 1 / span 2; grid-column: 1 / span 1"
        >
          Interface
        </div>
        <div
          class="cell header bold main"
          style="
            grid-row: 1;
            grid-column: 2 / span 2;
            border-top: 1px solid #e0e0e0;
          "
        >
          Registered {{ totalRegisteredUsage }}/{{ totalRegisteredAllocation }}
        </div>
        <div
          class="cell header bold main top-right-corner"
          style="grid-row: 1; grid-column: 4 / span 2"
        >
          Interact with Website Guests {{ totalCasualUsage }}/{{
            totalCasualAllocation
          }}
        </div>
        <!-- second row -->
        <!-- <div
          class="cell header left bold"
          style="grid-row: 2; grid-column: 1"
        ></div> -->
        <div class="cell header bold" style="grid-row: 2; grid-column: 2">
          Usage
        </div>
        <div class="cell header bold" style="grid-row: 2; grid-column: 3">
          Allocation
        </div>
        <div class="cell header bold" style="grid-row: 2; grid-column: 4">
          Usage
        </div>
        <div class="cell header bold" style="grid-row: 2; grid-column: 5">
          Allocation
        </div>
        <!-- third row -->
        <div class="cell bold left" style="grid-row: 3; grid-column: 1">
          Website
        </div>
        <div class="cell" style="grid-row: 3; grid-column: 2">
          {{ websiteRegisteredUsage }}
        </div>
        <div class="cell" style="grid-row: 3; grid-column: 3">
          <v-text-field
            :disabled="
              loggedUser.role !== 'SuperAdmin' || organization.status !== 0
            "
            class="numOfAllowedInput mb-3"
            hide-details
            @change="numOfAllowedChange($event, 'Website')"
            height="16px"
            type="number"
            validate-on-blur
            :value="getProtocols('Website', true)"
          ></v-text-field>
          <!-- {{ websiteRegisteredAllocation }} -->
        </div>
        <div class="cell" style="grid-row: 3; grid-column: 4">
          {{ websiteGuestUsage }}
        </div>
        <div class="cell" style="grid-row: 3 / span 2; grid-column: 5">
          <v-text-field
            :disabled="
              loggedUser.role !== 'SuperAdmin' || organization.status !== 0
            "
            class="numOfAllowedInput mb-3"
            hide-details
            @input="numOfAllowedChange($event, 'Casual')"
            height="16px"
            type="number"
            validate-on-blur
            :value="getProtocols('Casual', true)"
          ></v-text-field>
        </div>
        <!-- fourth row -->
        <div class="cell bold left" style="grid-row: 4; grid-column: 1">
          SFTP folder
        </div>
        <div class="cell" style="grid-row: 4; grid-column: 2">
          {{ sftpRegisteredUsage }}
        </div>
        <div class="cell" style="grid-row: 4; grid-column: 3">
          <v-text-field
            :disabled="
              loggedUser.role !== 'SuperAdmin' || organization.status !== 0
            "
            class="numOfAllowedInput mb-3"
            hide-details
            @change="numOfAllowedChange($event, 'SFTP')"
            height="16px"
            type="number"
            validate-on-blur
            :value="getProtocols('SFTP', true)"
          ></v-text-field>
        </div>
        <div class="cell" style="grid-row: 4; grid-column: 4">
          {{ sftpGuestUsage }}
        </div>
        <!-- <div class="cell" style="grid-row: 4; grid-column: 5">
          <v-text-field
            :disabled="
              loggedUser.role !== 'SuperAdmin' || organization.status !== 0
            "
            class="numOfAllowedInput mb-3"
            hide-details
            @input="numOfAllowedChange($event, 'Casual')"
            height="16px"
            type="number"
            
            validate-on-blur
            :value="getProtocols('Casual', true)"
          ></v-text-field>
        </div> -->
        <!-- fifth row -->
        <div class="cell bold left" style="grid-row: 5; grid-column: 1">
          Kiosks
        </div>
        <div class="cell" style="grid-row: 5; grid-column: 2">
          {{ kioskUsage }}
        </div>
        <div class="cell" style="grid-row: 5; grid-column: 3">
          <v-text-field
            :disabled="
              loggedUser.role !== 'SuperAdmin' || organization.status !== 0
            "
            class="numOfAllowedInput mb-3"
            hide-details
            @change="numOfAllowedChange($event, 'kiosks')"
            height="16px"
            type="number"
            validate-on-blur
            :value="getProtocols('kiosks', true)"
          ></v-text-field>
        </div>
        <!-- sixth row -->
        <div
          class="cell bottom-left-corner bold left"
          style="grid-row: 6; grid-column: 1"
        >
          API
        </div>
        <div class="cell" style="grid-row: 6; grid-column: 2">
          {{ apiUsage }}
        </div>
        <div class="cell" style="grid-row: 6; grid-column: 3">
          <v-text-field
            :disabled="
              loggedUser.role !== 'SuperAdmin' || organization.status !== 0
            "
            class="numOfAllowedInput mb-3"
            hide-details
            @change="numOfAllowedChange($event, 'API')"
            height="16px"
            type="number"
            validate-on-blur
            :value="getProtocols('API', true)"
          ></v-text-field>
        </div>
        <!-- empty area -->
        <div
          class="cell empty"
          style="grid-row: 5; grid-column: 4 / span 2"
        ></div>
        <div
          class="cell empty bottom-right-corner"
          style="grid-row: 6; grid-column: 4 / span 2"
        ></div>
      </div>
      <!-- <v-data-table
        :headers="orgDefinitionsHeaders"
        hide-default-footer
        fixed-header
        class="wrapper-1 mw-220"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <WebsiteLicenses
              :protocolNumberRules="protocolNumberRules"
              :getProtocols="getProtocols"
              :numOfAllowedChange="numOfAllowedChange"
              :organization="organization"
              :actionType="actionType"
              :type="'Website'"
            />
            <WebsiteLicenses
              :protocolNumberRules="protocolNumberRules"
              :getProtocols="getProtocols"
              :numOfAllowedChange="numOfAllowedChange"
              :organization="organization"
              :actionType="actionType"
              :type="'SFTP'"
            />
            <Licenses
              v-for="(interFace, i) in licenses"
              :key="i"
              :interFace="interFace"
              :protocolNumberRules="protocolNumberRules"
              :getProtocols="getProtocols"
              :organization="organization"
              :numOfAllowedChange="numOfAllowedChange"
            />
          </tbody>
        </template>
      </v-data-table> -->
      <OnlineHelp page="settings" section="licenses" title="Licenses" />
    </div>
  </div>
</template>

<script>
//Base componentns
import OnlineHelp from '@/components/BaseComponents/OnlineHelp/OnlineHelp.vue'

//Childrens
import WebsiteLicenses from './Childrens/WebsiteLicenses/WebsiteLicenses.vue'
import Licenses from './Childrens/Licenses/Licenses.vue'

//Component file
import { langs, orgDefinitionsHeaders, licenses } from './OrgDefinitons'
import { mapGetters } from 'vuex'

export default {
  name: 'OrgDefinitions',
  data() {
    return {
      langs,
      orgDefinitionsHeaders,
      licenses,
      protocolNumberRules: {
        required: value => !!value || value === 0 || 'Required.',
        // isPositive: value =>
        //   (value > -1 && value < 100) || 'Only positive Numbers',
        // isInt: value => (value % 1 === 0 && value !== 'e') || 'Only Integers',
        // isMoreThanUsedCasual: value => {
        //   console.log('casual', value)
        //   let websiteAllocation = 0
        //   let sftpAllocation = 0
        //   const websiteLicense = this.organization.allowedLicenses.find(
        //     e => e.type === 'Website'
        //   )
        //   if (websiteLicense) {
        //     websiteAllocation = websiteLicense.numOfAllowed
        //   }
        //   const sftpLicense = this.organization.allowedLicenses.find(
        //     e => e.type === 'SFTP'
        //   )
        //   if (sftpLicense) {
        //     sftpAllocation = sftpLicense.numOfAllowed
        //   }
        //   console.log('websiteAllocation', websiteAllocation)
        //   console.log('sftpAllocation', sftpAllocation)
        //   console.log('casual', value)
        //     return websiteAllocation + sftpAllocation >= value || 'Not enough licenses'
        // },
        // isMoreThanUsed: type => {
        //   if (!this.organization.allowedLicenses) return true

        //   const license = this.organization.allowedLicenses.find(
        //     e => e.type === type
        //   )

        //   if (!license || license.numOfInUse > license.numOfAllowed) {
        //     return false
        //   }
        //   return true
        // },
      },
    }
  },
  props: {
    organization: Object,
    actionType: String,
  },
  components: { WebsiteLicenses, Licenses, OnlineHelp },
  computed: {
    ...mapGetters(['users', 'loggedUser']),
    totalRegisteredUsage() {
      return (
        this.websiteRegisteredUsage +
        this.sftpRegisteredUsage +
        this.kioskUsage +
        this.apiUsage
      )
    },
    totalRegisteredAllocation() {
      console.log(
        this.websiteRegisteredAllocation,
        this.sftpRegisteredAllocation,
        this.kioskAllocation,
        this.apiAllocation
      )
      return (
        this.websiteRegisteredAllocation +
        this.sftpRegisteredAllocation +
        this.kioskAllocation +
        this.apiAllocation
      )
    },
    totalCasualUsage() {
      return this.websiteGuestUsage + this.sftpGuestUsage
    },
    totalCasualAllocation() {
      return this.guestAllocation
    },
    websiteRegisteredUsage() {
      return this.getProtocols('Website', false)
    },
    websiteRegisteredAllocation() {
      return this.getProtocols('Website', true)
    },
    websiteGuestUsage() {
      return this.users.filter(
        user =>
          user.license === 'Website' && user.isAllowCasuals && user.status === 0
      ).length
    },
    sftpRegisteredUsage() {
      return this.getProtocols('SFTP', false)
    },
    sftpRegisteredAllocation() {
      return this.getProtocols('SFTP', true)
    },
    sftpGuestUsage() {
      return this.users.filter(
        user =>
          user.license === 'SFTP' && user.isAllowCasuals && user.status === 0
      ).length
    },
    kioskUsage() {
      return this.getProtocols('kiosks', false)
    },
    kioskAllocation() {
      return this.getProtocols('kiosks', true)
    },
    apiAllocation() {
      return this.getProtocols('API', true)
    },
    apiUsage() {
      return this.getProtocols('API', false)
    },
    guestAllocation() {
      return this.getProtocols('Casual', true)
    },
  },
  methods: {
    getProtocols(type, allowed) {
      if (!this.organization.allowedLicenses) return 0
      if (this.organization.allowedLicenses.length) {
        const proto = this.organization.allowedLicenses.find(
          e => e.type === type
        )
        if (proto && allowed) return proto.numOfAllowed
        else if (proto) return proto.numOfInUse
        return 0
      }
      return 0
    },
    numOfAllowedChange(val, type) {
      console.log('val', val)
      // if the the type is casual and it is more than 0
      if (type === 'Casual' && +val > 0) {
        this.organization.casualUsersDefinitions.isActive = true
      }

      // if the type is casual and it is 0
      else if (type === 'Casual' && +val === 0) {
        this.organization.casualUsersDefinitions.isActive = false
      }

      const value = 
      // parseInt(
        Number(val)
      // )
      console.log(typeof value)
      //if the value is more than 0
      console.log('val', val)
      console.log('value', value)
      if (value > 0 || value < 0) {
        console.log('value bigger than zero', value)
        if (
          //checks if there is already an object with the same type
          this.organization.allowedLicenses.length &&
          this.organization.allowedLicenses.some(e => e.type === type)
        ) {
          this.organization.allowedLicenses =
            this.organization.allowedLicenses.map(e => {
              return e.type === type ? { ...e, numOfAllowed: value } : e
            })
          return
        } else {
          const newProtocol = {
            type,
            numOfAllowed: value,
            numOfInUse: 0,
          }
          this.organization.allowedLicenses.push(newProtocol)
        }
      }

      // if the number is 0
      else {
        console.log('value is zero or less', value)
        this.organization.allowedLicenses = this.organization.allowedLicenses
          .map(lic => {
            if (lic.type === type) {
              //if there are used users retun this to cause an error
              if (value === 0 && lic.numOfInUse === 0) {
                return undefined
              } else return { ...lic, numOfAllowed: value }
            }
            return lic
          })
          .filter(el => el !== undefined)
          console.log(
            'this.organization.allowedLicenses',
            this.organization.allowedLicenses
          )
      }
    },
  },
}
</script>

<style scoped src="./OrgDefinitions.css"></style>
<style scoped>
.licenses-grid {
  max-width: 800px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(6, 50px);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
.cell {
  font-size: 16px;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  /* height: 50px; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}
.bold {
  font-weight: 500;
}
.header {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #000;
  display: flex;
  justify-content: center;
}
.main {
  font-size: 18px;
}
.left {
  justify-content: flex-start;
  border-left: 1px solid #e0e0e0;
}
.border-right {
  border-right: 1px solid #e0e0e0;
}

.border-none {
  border-bottom: none;
}
.top-left-corner {
  border-top-left-radius: 10px;
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
}
.top-right-corner {
  border-top-right-radius: 10px;
  border-top: 1px solid #e0e0e0;
}
.bottom-right-corner {
  border-bottom-right-radius: 10px;
}
.bottom-left-corner {
  border-bottom-left-radius: 10px;
}
.numOfAllowedInput {
  max-width: 30px;
  padding: 0;
  margin-top: 11px;
}
.numOfAllowedInput >>> input {
  text-align: center;
  font-size: 14.5px;
  padding: 0;
  margin: 0;
}
</style>
